import type { ActivityChange } from 'types';

export interface ActivityChangeEntry {
    field: string;
    from: string;
    to: string;
}

/** "application.checklist_generated" -> "Checklist generated" */
export const humanizeEventLabel = (value: string): string => {
    const segment = value.includes('.') ? (value.split('.').pop() ?? value) : value;
    const words = segment.replace(/[_-]+/g, ' ').trim();
    return words ? words.charAt(0).toUpperCase() + words.slice(1) : value;
};

export const formatChangeValue = (value: unknown): string => {
    if (value === null || value === undefined || value === '') return '—';
    if (typeof value === 'object') {
        try {
            return JSON.stringify(value);
        } catch {
            return String(value);
        }
    }
    return String(value);
};

/** Structured field diffs for readable UI (label + from/to). */
export const buildChangeEntries = (
    changes: Record<string, ActivityChange> | null
): ActivityChangeEntry[] => {
    if (!changes) return [];
    return Object.entries(changes).map(([field, diff]) => ({
        field: humanizeEventLabel(field),
        from: formatChangeValue(diff?.from),
        to: formatChangeValue(diff?.to),
    }));
};
